export default "__VITE_ASSET__CiNR8wLx__"